import { middlewareConnector } from '@middleware-connector'
import { computed, ref, toValue } from 'vue'
import { useRoles } from './useRoles'
import { useCurrentUser } from './useCurrentUser'

const _allSchools = ref(undefined)

export const useSchools = () => {
    const { uuidCorporations } = useCurrentUser()
    const { hasAdminRole } = useRoles()
    const error = ref(null)
    const errorMessage = computed(() => error.value?.response?.data?.userMessage || error.value?.message)

    //lazy load schools
    const allSchools = computed(() => {
        if (!_allSchools.value) {
            initSchools()
        }
        return _allSchools.value || []
    })

    //only the schools the user has access to
    const userSchools = computed(() => {
        if (hasAdminRole.value) {
            return allSchools.value
        }
        return allSchools.value?.filter(school => toValue(uuidCorporations).includes(school.uuid)) || []
    })


    const getSchools = async () => {
        if (error.value) {
            error.value = null
        }
        return middlewareConnector.getSchools()
        .catch(err => {
            error.value = err
            return []
        })
    }

    const initSchools = async () => {
        _allSchools.value = await getSchools()
    }

    return {
        allSchools,
        userSchools,
        errorMessage
    }
}
